module.exports = __webpack_public_path__ + "img/style-2.77be4cd0.png";